
export const ApplicationVersion = "ApplicationVersion"
export const LastVersionTime = "LastVersionTime"

export const STORAGE_ACCOUNT = "Account";
export const STORAGE_TOKEN = "Token";

export const NotShowAgainToday = "NotShowAgainToday";
// ---------------------------------------------------------------------
// Wholesaler Cache Key List - 1 hour keeping...
// ---------------------------------------------------------------------
export const WHOLE_PRODUCT_LIST = "WholeProductList-";
export const WHOLE_AVAILABLE_PRODUCTS = "WholeAvailableProducts"; // Active and Out of stock Products...
export const ACTIVE_PENDING_CUSTOMERS = "ActivePendingCustomers";
export const WHOLE_CUSTOMERS_FAVOURITES = "WholeCustomersFavourites-";

export const WHOLE_CHAT_ROOMS = "WholeChatRooms";

export const PERMISSION_SMART_ORDER = "PermissionSmartOrder"


// ---------------------------------------------------------------------
// Customer Cache Key List - 1 hour Keeping...
// ---------------------------------------------------------------------
export const CUSTOMER_ALL_WHOLESALERS = "CustomerAllWholesalers";   // If a customer has multipe wholesaler...
export const MY_WHOLESALER_INFO = "MyWholesalerInfo";

export const ACTIVE_PRODUCT_LIST = "ActiveProductList";  // Customer Product Cache..
export const ACTIVE_CUSTOMER_LIST = "ActiveCustomerList";

export const PRODUCT_CLASS_LIST = "ProductClassList";
export const CART_ITEM_LIST = "CartItemList";

export const LATEST_ORDER_LIST = "LatestOrderList";
export const NEW_PRODUCT_LIST = "NewProductList";
export const MY_FAVOURITE_LIST = "MyFavouriteList";


